import { getYYYYMMDDLocal } from 'src/utils/api'

export const formatDates = ({ date_from, date_to, ...filters }) => {
  if (date_from) {
    filters.date_from = getYYYYMMDDLocal(date_from);
  }

  if (date_to) {
    filters.date_to = getYYYYMMDDLocal(date_to);
  }

  return filters;
};
